import axios from "axios";
import Login from "../components/Login";

let refresh = false;

axios.interceptors.response.use(
  (resp) => resp,
  async (error) => {
    if (error.response.status === 401 && !refresh) {
      refresh = true;
      console.log(localStorage.getItem("refresh_token"));
      const response = await axios.post(
        "https://my-pg.vercel.app/token/refresh/",
        {
          refresh: localStorage.getItem("refresh_token"),
        }
      );
      if (response.status === 200) {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + response.data["access"];

        localStorage.setItem("access_token", response.data.access);
        localStorage.setItem("refresh_token", response.data.refresh);
        return axios(error.config);
      }
      if (response.status === 401) {
        <Login />;
      }
    }
    refresh = false;
    return error;
  }
);
